import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {ReactElement} from 'react'

import {useRevalidateBatchOutdated} from '../hooks/use-revalidate-batch-outdated'

/**
 * Headless component that mounts the per-item batch outdated reconciler once under the layout store,
 * on every PR tab. Renders no UI — see {@link useRevalidateBatchOutdated}.
 *
 * Gated on `unified_batch_pr_comments` so flag-off users never mount the inner reconciler and take
 * on no markers/batch store subscriptions.
 */
export function BatchOutdatedRevalidator(): ReactElement | null {
  if (!isFeatureEnabled('unified_batch_pr_comments')) return null
  return <BatchOutdatedRevalidatorInner />
}

function BatchOutdatedRevalidatorInner(): null {
  useRevalidateBatchOutdated()
  return null
}
